import React, { forwardRef, Ref } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Typography } from '../Typography/Typography';
import styles from './Dropdown.module.scss';
import classes from 'classnames/bind';

const cx = classes.bind(styles);

export interface IOption {
  isDisabled?: boolean;
  id: string | number;
  name: string | JSX.Element;
  isHighlighted?: boolean;
  onOptionClick: () => void;
  dataTestId?: string;
}

export interface IDropdown {
  position?: 'right' | 'left' | 'top' | 'bottom';
  options: IOption[];
  isOpen: boolean;
  maxHeight?: number;
}

const Dropdown = ({ position = 'right', options, isOpen, maxHeight }: IDropdown, ref: Ref<HTMLDivElement> | null) => {
  return (
    <CSSTransition nodeRef={ref} in={isOpen} timeout={300} unmountOnExit>
      <div
        ref={ref}
        className={cx('dropdown', {
          [`dropdown-${position}`]: position,
          'dropdown-closed': !isOpen,
        })}
      >
        <ul className={styles['dropdown-menu']} style={{ maxHeight }} role="list">
          {options.map((option: IOption) => (
            <li
              key={option.id}
              role="listitem"
              aria-disabled={option?.isDisabled}
              aria-label={option.name.toString()}
              className={cx('dropdown-item', {
                'is-highlighted': option?.isHighlighted,
                'is-disabled': option?.isDisabled,
              })}
              onClick={(event) => {
                event.stopPropagation();
                option.onOptionClick();
              }}
              data-testid={option.dataTestId}
            >
              <Typography aria-label={`option-${option.name}`}>{option.name}</Typography>
            </li>
          ))}
        </ul>
      </div>
    </CSSTransition>
  );
};

export default forwardRef(Dropdown);
